import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/accordion-context.ts
import { createDescendantContext } from "@chakra-ui/descendant";
import { createContext } from "@chakra-ui/react-context";
var _createContext = createContext({
    name: "AccordionStylesContext",
    hookName: "useAccordionStyles",
    providerName: "<Accordion />"
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  AccordionStylesProvider = _createContext2[0],
  useAccordionStyles = _createContext2[1];
var _createContext3 = createContext({
    name: "AccordionItemContext",
    hookName: "useAccordionItemContext",
    providerName: "<AccordionItem />"
  }),
  _createContext4 = _slicedToArray(_createContext3, 2),
  AccordionItemProvider = _createContext4[0],
  useAccordionItemContext = _createContext4[1];
var _createDescendantCont = createDescendantContext(),
  _createDescendantCont2 = _slicedToArray(_createDescendantCont, 4),
  AccordionDescendantsProvider = _createDescendantCont2[0],
  useAccordionDescendantsContext = _createDescendantCont2[1],
  useAccordionDescendants = _createDescendantCont2[2],
  useAccordionDescendant = _createDescendantCont2[3];
export { AccordionStylesProvider, useAccordionStyles, AccordionItemProvider, useAccordionItemContext, AccordionDescendantsProvider, useAccordionDescendantsContext, useAccordionDescendants, useAccordionDescendant };